module.exports = __webpack_public_path__ + "img/LX.4af771c7.svg";